import { render, staticRenderFns } from "./InventoryAllOrderList.vue?vue&type=template&id=b2f77318&"
import script from "./InventoryAllOrderList.vue?vue&type=script&lang=js&"
export * from "./InventoryAllOrderList.vue?vue&type=script&lang=js&"
import style0 from "./InventoryAllOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports